import app from './Vue/app';
import {listen} from 'quicklink';

app.mount('main');
if(window.location.protocol != 'https:' && window.location.hostname == 'www.punchcigars.com'){
    window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
}

if(window.location.hostname !== 'localhost' && !window.location.href.includes('Security')){
    window.addEventListener('load', () => {
        listen({
            ignores: [
                (uri, elem) => {
                    return elem.hasAttribute('noprefetch') || uri.includes('#')
                }
            ],
        });
    });
}
